




























































import { AutomatoFinitoDeterministico } from "@/models/automato-finito-deterministico";
import { AutomatoFinitoNaoDeterministico } from "@/models/automato-finito-nao-deterministico";
import { Vue, Component, Prop } from "vue-property-decorator";

@Component
export default class Transicoes extends Vue {
  @Prop({ required: true }) automato!:
    | AutomatoFinitoDeterministico
    | AutomatoFinitoNaoDeterministico;

  private get disabled(): boolean {
    return (
      this.automato.estados.size === 0 || this.automato.alfabeto.size === 0
    );
  }

  private get multiplosDestinos(): boolean {
    return this.automato instanceof AutomatoFinitoNaoDeterministico;
  }

  private get estados(): string[] {
    return [...this.automato.estados];
  }

  private get alfabeto(): string[] {
    return [...this.automato.alfabeto];
  }

  adicionarTransicao() {
    if (!this.multiplosDestinos)
      (this.automato as AutomatoFinitoDeterministico).transicoes.push([
        "",
        "",
        ""
      ]);
    else
      (this.automato as AutomatoFinitoNaoDeterministico).transicoes.push([
        "",
        "",
        new Set()
      ]);
  }

  atualizarEstadosDestino(
    novosEstados: string[],
    transicao: [string, string, Set<string>]
  ): void {
    Vue.set(transicao, 2, novosEstados);
  }

  log(value: any) {
    console.log(new Set(value));
  }
}
